// extracted by mini-css-extract-plugin
export default {"team":"team_team__TvLYt","socials":"team_socials__6QT-C"};